import { render, staticRenderFns } from "./ReplayDashboard.vue?vue&type=template&id=13dd1c3e&scoped=true"
import script from "./ReplayDashboard.vue?vue&type=script&lang=js"
export * from "./ReplayDashboard.vue?vue&type=script&lang=js"
import style0 from "./ReplayDashboard.vue?vue&type=style&index=0&id=13dd1c3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dd1c3e",
  null
  
)

export default component.exports